import React from 'react';
import ProjectLayout from './Projects';
import VideoShowcase from './VideoShowcase';
import TypeAnimation from 'react-type-animation';

const ComponentOne = () => {
  return (
    <TypeAnimation
      cursor={true}
      sequence={["Some of my favorite software projects I’ve built.", 12300, '']}
      repeat={Infinity}
      wrapper="p"
    />
  );
};

const Portfolio = () => {
  return (
    <section id='portfolio' className='section bg-primary'>
      <div className='container mx-auto'>
        <div className='flex flex-col items-center text-center'>
          <h2 className='section-title relative before:absolute before:opacity-40 before:-top-[2rem] before:-left-3/4 before:hidden before:lg:block'>
            My projects
          </h2>
          <p className='subtitle'>
           <ComponentOne/>
          </p>
        </div>
        <VideoShowcase />
        <ProjectLayout />
      </div>
    </section>
  );
};

export default Portfolio;
